module.exports = {
      id: "check-usage",
      viewBox: "0 0 11 12",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#check",
      toString: function () {
        return this.url;
      }
    }